import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
const CurrentSub = ({currentPlan}) => {
    return (  <div className="bg-gray-100 p-4 rounded-xl shadow-sm">
        <h4 className="text-lg font-bold text-yellow-600 mb-2">
          Current Subscription
        </h4>
        {currentPlan ? (
          <div className="space-y-1">
            <p className="text-gray-800 font-semibold">
              Plan: {currentPlan?.plan.name}
            </p>
            <p className="text-gray-500">
              Status:{" "}
              <span
                className={`font-medium ${
                  currentPlan.status === "Active"
                    ? "text-green-600"
                    : "text-red-500"
                }`}
              >
                <FontAwesomeIcon
                  icon={
                    currentPlan.status === "Active"
                      ? faCheckCircle
                      : faTimesCircle
                  }
                  className="mr-1"
                />
       
                {currentPlan.status}
              </span>
            </p>
            <p className="text-gray-500">
              Valid from:{" "}
              <span className="text-gray-700">{currentPlan.createdAt.split("T")[0]}</span>{" "}
            {currentPlan.endDate!==null   &&  <span className="text-gray-700"><span className="text-gray-500">to </span>{currentPlan.endDate}</span>
            }</p>
            <p className="text-gray-500">
              Quantity:{" "}
              <span className="text-gray-700">
                {currentPlan.quantity}
              </span>
            </p>
            <p className="text-gray-500">
              Amount Paid:{" "}
              <span className="text-gray-700">
                ₦{currentPlan.amount.toFixed(2)}
              </span>
            </p>
          </div>
        ) : (
          <p className="text-gray-500">No subscription information found.</p>
        )}
      </div> );
}
 
export default CurrentSub;